import { createSelector } from "reselect";
import { State } from "../../../state";
import {
  getBalanceSheetAccountValues,
  getCashFlowAccountValues,
  getIncomeStatementAccountValues
} from "../derivedModel/selector";
import { buildHighlightedValueLensesForSelectedCells } from "./highlightedValueLensesForSelectedCells";
import {
  buildSelectedCellMap,
  getIndexOfPeriodSelected,
  isCellSelected
} from "./selectedCellMap";

export const getSelectedCells = (state: State) => state.selectedCells;

export const getSelectedCellMap = createSelector(
  getSelectedCells,
  buildSelectedCellMap
);

export const getCellSelectedFn = createSelector(
  getSelectedCellMap,
  selectedCellMap => isCellSelected(selectedCellMap)
);

export const getPeriodSelectedFn = createSelector(
  getSelectedCellMap,
  selectedCellMap => getIndexOfPeriodSelected(selectedCellMap)
);

export const getHighlightedValueLenses = createSelector(
  getIncomeStatementAccountValues,
  getBalanceSheetAccountValues,
  getCashFlowAccountValues,
  getSelectedCells,
  buildHighlightedValueLensesForSelectedCells
);



// WEBPACK FOOTER //
// ./src/spread/model/selectedCells/selector.ts